import React from "react";
import { Brain } from "lucide-react";

import DossierModal from "./DossierModal.jsx";
import useDossier from "./useDossier.js";
import "./dossier.css";

export default function ResearchProspectButton({ lead }) {
  const dossier = useDossier(lead?.id);

  return (
    <>
      <button type="button" className="Lms-Detail-Action" onClick={dossier.openModal}>
        <Brain size={17} /> <span>Research Prospect</span>
      </button>
      <DossierModal lead={lead} dossier={dossier} />
    </>
  );
}
